import { useEffect, useRef, useState } from 'react';
import { debounce } from './functions';
function useFooterMargin(footerApi, currentBreakpoint) {
    const footerRef = useRef(null);
    const [footerHeight, setFooterHeight] = useState(0);
    const addMarginBottomForFooter = (footer) => {
        const root = document.documentElement;
        const header = document.querySelector('header');
        // @ts-ignore - window.mqObj.md as number
        if (window.innerWidth < window.mqObj.md || footer.offsetHeight >= window.innerHeight - header.offsetHeight) {
            root.classList.remove('fixed-footer');
            // @ts-ignore - window.mqObj.md as number
        }
        else if (window.innerWidth >= window.mqObj.md) {
            root.classList.add('fixed-footer');
            root.style.setProperty('--footer-margin', footer.clientHeight + 'px');
        }
    };
    const resizeObserverCallback = (entries) => {
        const currentHeight = entries[0].target.offsetHeight;
        if (currentHeight !== footerHeight) {
            //check if footer sizes are changed (width for window resize and height for delayed renderings/inner node changes), in order to avoid unwanted updates
            addMarginBottomForFooter(entries[0].target);
            setFooterHeight(currentHeight);
        }
    };
    const intersectionObserverCallback = (entries) => {
        if (entries) {
            const footerWidthObserver = new ResizeObserver(debounce(resizeObserverCallback, 500));
            addMarginBottomForFooter(entries[0].target);
            if (entries[0].isIntersecting) {
                footerWidthObserver.observe(entries[0].target);
            }
            else {
                footerWidthObserver.disconnect();
            }
        }
    };
    useEffect(() => {
        var _a;
        if (footerApi && footerRef.current) {
            // @ts-ignore - window.mqObj as object
            if (currentBreakpoint >= window.mqObj.md) {
                const maincontent = document.getElementById('maincontent');
                const isCartOrCheckout = ['cart-show'].includes(document.body.id) || document.body.classList.contains('checkout');
                if (maincontent && !isCartOrCheckout && !window.appmode) {
                    const footer = (_a = footerRef.current) === null || _a === void 0 ? void 0 : _a.closest('#footer'); //footerRef is the react component, that is grand children of <footer/> tag (node element to check)
                    const footerIntersectionObserver = new IntersectionObserver(intersectionObserverCallback, { rootMargin: '40px' });
                    footerIntersectionObserver.observe(footer);
                    return () => {
                        footerIntersectionObserver.disconnect();
                    };
                }
            }
            else if (document.documentElement.classList.contains('fixed-footer')) {
                document.documentElement.classList.remove('fixed-footer');
            }
        }
    }, [footerApi, currentBreakpoint]);
    return footerRef;
}
export default useFooterMargin;
